/* JS is now deactivated in this project, use .ts files instead */

import { register } from '../../../JavaScript/Utils'

export const SearchToggle = (el: HTMLElement) => {

  const toggleClass: HTMLElement = el.querySelector('.comp-search--toggle')

  // toggle class mobile navigation
  toggleClass.addEventListener('click', (e: MouseEvent) => {
    (<HTMLElement>e.currentTarget).classList.toggle('is--active');
  })
}

register('SearchToggle', SearchToggle)

